"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var YotpoStarSvg_1 = require("./YotpoStarSvg");
var YotpoStar = function (_a) {
    var score = _a.score, size = _a.size, id = _a.id, color = _a.color, starFilledImg = _a.starFilledImg, starOutlinedImg = _a.starOutlinedImg;
    // Define the number of each star to render
    var filled = Math.floor(score);
    var outlined = 5 - score;
    return ((0, preact_1.h)("div", { class: "yotpo-star yotpo-star--".concat(size) },
        filled > 0 &&
            __spreadArray([], Array(filled), true).map(function (_, index) {
                return starFilledImg ? ((0, preact_1.h)("img", { src: starFilledImg, key: index, alt: "full-star", class: "yotpo-star__img yotpo-star__img--".concat(size) })) : ((0, preact_1.h)(YotpoStarSvg_1.default, { color: color, id: id, key: index, proportion: score - filled, size: size, type: "filled" }));
            }),
        score < 5 && ((0, preact_1.h)(YotpoStarSvg_1.default, { proportion: score - filled, size: size, id: id, color: color, type: "partial" })),
        outlined > 1 &&
            __spreadArray([], Array(Math.ceil(outlined - 1)), true).map(function (_, index) {
                return starOutlinedImg ? ((0, preact_1.h)("img", { src: starOutlinedImg, alt: "outline-star", class: "yotpo-star__img yotpo-star__img--".concat(size), key: index })) : ((0, preact_1.h)(YotpoStarSvg_1.default, { color: color, id: id, key: index, proportion: score - filled, size: size, type: "outlined" }));
            })));
};
exports.default = YotpoStar;
